module.exports = __webpack_public_path__ + "static/media/cloud-showers-heavy.b23384f0.svg";